import { useSearch } from "@tanstack/react-router";
import { useCloseMaskDialog } from "./use-close-mask-dialog";

type Options = { clearKeys?: string[] };

export function useMaskDialog(action: string, options?: Options) {
  const current = (useSearch as any)({
    strict: false,
    select: (s: { action?: string } | undefined) =>
      (s?.action as string | undefined) ?? null,
    structuralSharing: true,
  }) as string | null;

  const close = useCloseMaskDialog(options);

  return {
    isOpen: current === action,
    close,
    onOpenChange: (open: boolean) => {
      if (!open) close();
    },
  };
}
